import React, { useEffect } from 'react';
import { Map, GoogleApiWrapper, Polygon, Marker } from 'google-maps-react';
import styles from '@styles/punch.module.css';

class PunchGeolocationMap extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            bounds: null,
            zoneMarker: null,
            coordinates: !this.props.currentZone ? [] : this.props.currentZone.coordinates
        };
    }

    componentDidMount() {
        this.getBounds();
    }

    getBounds = () => {
        let bounds = new this.props.google.maps.LatLngBounds();

        if (this.props.currentZone) {
            for (var i = 0; i < this.props.currentZone.coordinates.length; i++) {
                bounds.extend(this.props.currentZone.coordinates[i]);
            }

            this.setState({ zoneMarker: bounds.getCenter() });
        }

        bounds.extend(this.props.currentPosition);

        this.setState({ bounds: bounds });
    }

    render() {
        return (
            <Map
                google={this.props.google}
                bounds={this.state.bounds}
                className={styles.map}
            >
                {this.state.zoneMarker != null &&
                    <Marker
                        position={this.state.zoneMarker}
                        strokeColor="red"
                    />
                }
                <Marker
                    position={this.props.currentPosition}
                    icon={{
                        path: this.props.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                        strokeColor: "green",
                        scale: 6
                    }}
                />
                <Polygon
                    paths={this.state.coordinates}
                    options={{
                        fillColor: "#000",
                        fillOpacity: 0.4,
                        strokeColor: "red",
                        strokeOpacity: 1,
                        strokeWeight: 2
                    }} />
            </Map>);
    }
};

export default GoogleApiWrapper(props => ({ apiKey: props.googleMapsApiKey }))(PunchGeolocationMap);